/**
 * Catch error if query rejected and redirect to logged in page
 */

export const onQueryStartedErrorToast = async (args: any, { queryFulfilled }: any) => {

  try {
    await queryFulfilled;
  } catch (error: any) {
    if (error.error.status === 401) {
      window.location.replace('/');
    }
  }
};
